/**
 * Price formats for display, the same as the storefront's Smarty modifiers
 * (FormatPrice() in frontend/etc/utils.php): two decimals after a comma and no
 * thousands separator. The shop format ends whole amounts in ",-" (2000,-),
 * the cart and account format keeps ",00" (2000,00).
 *
 * Takes the dot-decimal numbers the data attributes and json answers carry.
 * Empty counts as 0; anything else non-numeric is returned unchanged.
 */

const format = (value) => {
	if (value === null || value === undefined || value === '') {
		value = 0
	}

	const number = Number(value)
	if (!Number.isFinite(number)) {
		return String(value)
	}

	// round half away from zero like PHP's number_format, not to even like toFixed
	const cents = Math.round(Math.abs(number) * 100 + 1e-9)
	const sign = number < 0 && cents > 0 ? '-' : ''

	return (
		sign + Math.floor(cents / 100) + ',' + String(cents % 100).padStart(2, '0')
	)
}

export const cartPrice = (value) => format(value)

export const shopPrice = (value) => {
	const price = format(value)

	return price.endsWith(',00') ? price.slice(0, -2) + '-' : price
}
